<template>
    <div class="registe">
        <top-header :hideEmail="true"></top-header>
        <div class="registe-form">
            <div class="form">
                <el-form label-width="115px" :model="registeForm" ref="registeForm" :rules="rules">
                    <h1>注册账号</h1>
                    <div class="form-title"><span>注册信息</span></div>
                    <el-form-item label="注册邮箱" prop="email">
                        <el-input v-model="registeForm.email" placeholder="注册邮箱"></el-input>
                    </el-form-item>
                    <el-form-item label="设置密码" prop="password">
                        <el-input type="password" v-model="registeForm.password" placeholder="输入登录密码"></el-input>
                        <!-- <p class="form-tip">密码必须包含数字、字母，区分大小写，最短8位，区分大小写</p> -->
                    </el-form-item>
                    <el-form-item label="再次输入密码" prop="password2">
                        <el-input type="password" v-model="registeForm.password2" placeholder="再次输入密码"></el-input>
                    </el-form-item>
                    <div class="form-title"><span>基本信息</span></div>
                    <el-form-item label="公司名称" prop="company">
                        <el-input v-model="registeForm.company" placeholder="公司名称"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人姓名" prop="contact">
                        <el-input v-model="registeForm.contact" placeholder="姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="phone">
                        <el-input v-model="registeForm.phone" placeholder="手机号"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox v-model="registeForm.checked">
                            <span>我同意并遵守</span> <router-link to="/protocol">《猛犸充电开放平台开发者服务协议》</router-link> 
                        </el-checkbox>      
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('registeForm')">确定</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="doc-link">
                <a>联系商务支持</a>
                <a>联系技术支持</a>
            </div>
            <p class="company-phone">400-600-5288</p>
        </div>
    </div>
</template>
<script>
import topHeader from '@/components/top-header'
import {apiJson, http} from '@/utils/http'
import {Message} from 'element-ui'
export default {
    data () {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.registeForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        }
        return {
            registeForm: {
                email: '',
                password: '',
                password2: '',
                company: '',
                contact: '',
                phone: '',
                checked: false
            },
            rules: {
                email: [
                    {required: true, message: '请输入邮箱号', trigger: 'blur'},
                    {
                        pattern: /^[A-Za-z0-9]+([-_.][A-Za-z0-9]+)*@([A-Za-z0-9]+[-.])+[A-Za-z0-9]{2,5}$/, 
                        message: '请输入正确的邮箱号', 
                        trigger: 'blur'
                    }
                ],
                password: [
                    {required: true, message: '请输入密码', trigger: 'blur'},
                    {
                        pattern:/^[a-zA-Z0-9_-]{8,}$/, 
                        message: '密码必须包含数字、字母，区分大小写，最短8位，区分大小写', 
                        trigger: 'blur'
                    }
                ],
                password2: [
                    {required: true, message: '请再次输入密码', trigger: 'blur'},
                    {
                        validator:validatePass,  
                        trigger: 'blur'
                    }
                ],
                company: [
                    {required: true, message: '请输入所属公司', trigger: 'blur'},
                    {
                        pattern: /^[^\s]*$/,
                        message: "输入的内容包含空格",
                        trigger: "blur"
                    }
                ],
                contact: [
                    {required: true, message: '请输入联系人姓名', trigger: 'blur'},
                    {
                        pattern: /^[^\s]{0,12}$/,
                        message: "输入的姓名过长或包含空格",
                        trigger: "blur"
                    }
                ],
                phone: [
                    {required: true, message: '请输入手机号', trigger: 'blur'},
                    {
                        pattern: /^\d{11}$/,
                        message: "手机号格式错误",
                        trigger: "blur"
                    }
                ]
            }
        }
    },
    created () {
        localStorage.removeItem('token')
        localStorage.removeItem('email')
    },
    components: {
        topHeader
    },
    methods: {
        submitForm(registeForm) {
            this.$refs[registeForm].validate(valid => {
                if (valid && this.registeForm.checked) {
                    console.log(this.registeForm)
                    let data = {
                        emial: this.registeForm.email,
                        password: this.registeForm.password,
                        company: this.registeForm.company,
                        contact: this.registeForm.contact,
                        phone: this.registeForm.phone
                    }
                    http(apiJson.register, this.registeForm)
                    .then(res => {
                        console.log(res)
                        if(res && res.code == 0) {
                            Message.success("注册成功")
                            this.$router.push('/login')
                        }else {
                            Message.error("注册失败:" + res.message)
                        }
                        
                    }).catch(err => {
                        Message.error("注册失败")
                    })
                } else {
                    Message.warning("请填写相关信息并勾选遵守相关协议!")
                    return false;
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
    @import 'src/assets/scss/form.scss';
    .registe-form {
        width: 1400px;
        height: 930px;
        margin: 24px auto 50px;
        border: 1px solid #e5e5e5;
        .el-form {
            width: 450px;
            border: none;
            h1 {
                margin-top: 50px;
                margin-bottom: -48px;
            }
            
            .form-title {
                border: 0;
                margin-bottom: 32px;
            }
            .form-tip {
                font-size: 12px;
                color: #999999;
                height: 16px;
                line-height: 16px;
                margin-top: 10px;
            }
        }
    }
    .doc-link {
        width: 236px;
        height: 19px;
        margin: 50px auto 15px;
        color: #666666;
        font-size: 14px;
        a:first-child {
            padding-right: 25px;
            border-right: 1px solid #666666;
        }
        a:last-child {
            padding-left: 25px;
        }
    }
    .company-phone {
        text-align: center;
        font-size: 14px;
        color: #666666;
    }
</style>




// WEBPACK FOOTER //
// src/pages/Registe/registe.vue